module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-44.6642690b.jpg";